<template>
  <div>
    <router-view v-show="$route.matched.length==3"></router-view>
    <PageHeaderLayout v-show="$route.matched.length==2">
      <div class="main-page-content">
        <el-row class="table-header">
          <el-col>
            <ApeButton name="添加课程" type="primary" icon="icon-tianjiacaidan2" permission="course_create" @click="addButton(0)"></ApeButton>
          </el-col>
        </el-row>
        <el-row class="table-search">
          <el-form size="medium" :inline="true" :model="searchCondition" class="demo-form-inline">
            <el-form-item label="分类">
              <el-cascader
                placeholder="选择分类"
                :props="cascaderProps"
                :options="searchCourse"
                v-model="searchCondition.selected_category"
                show-all-levels
                clearable
                filterabl
              ></el-cascader>
            </el-form-item>
            <el-form-item label="标题">
              <el-input v-model="searchCondition.title" placeholder="输入标题" clearable></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="searchButton">查询</el-button>
            </el-form-item>
          </el-form>
        </el-row>
        <ApeTable ref="apeTable" :data="courseList" :columns="columns" :loading="loadingStaus" :pagingData="pagingData" @switchPaging="switchPaging" highlight-current-row>
          <el-table-column
            width="240"
            label="操作">
            <template slot-scope="scope">
              <span>
                <ApeButton name="编辑" size="mini" icon="el-icon-edit" permission="course_edit" @click="editButton(scope.row.id)"></ApeButton>
                <ApeDelButton permission="course_delete" @click="deleteButton(scope.row.id)"></ApeDelButton>
              </span>
            </template>
          </el-table-column>
        </ApeTable>
      </div>
    </PageHeaderLayout>
  </div >
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import ApeTable from '@/components/ApeTable'
import ApeButton from '@/components/ApeButton'
import ApeDelButton from '@/components/ApeDelButton'
import { mapGetters } from 'vuex'

export default {
  components: {
    PageHeaderLayout,
    ApeTable,
    ApeButton,
    ApeDelButton
  },
  data() {
    return {
      loadingStaus: true,
      columns: [
        {
          title: '封面',
          type: 'image',
          value: 'cover_url',
          width: 80
        },
        {
          title: '课程信息',
          value: [
            {label:'ID&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;号：',value:'id'},
            {label:'标&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;题：',value:'title'},
            {label:'课程类型：',value:'type_alias'},
            {label:'连载状态：',value:'serial_alias'},
            {label:'创建时间：',value:'created_at'},
          ]
        },
        {
          title: '课程信息',
          value: [
            {label:'价&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;格：',value:'price'},
            {label:'课程状态：',value:'status_alias'},
            {label:'课程时长：',value:'duration_alias'},
            {label:'学习人数：',value:'learning_nums'},
            {label:'点播次数：',value:'play_nums'},
          ]
        }
      ],
      // element的cascader的props值
      cascaderProps:{
        label:'display_name',
        value:'id',
      },
      searchCourse: [],
      // 搜索条件
      searchCondition:{
        selected_category:[]
      },
      // 表格列表数据
      courseList:[],
      // 分页信息
      pagingData:{
        is_show: true,
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0,
        // 分页的offset,序号列使用
        offset:0,
      },
    }
  },
  computed: {
    ...mapGetters(['userPermissions','buttonStyle'])
  },
  watch: {
    "$route.matched" : function(n,o) {
      if (n.length === 2) {
        this.initCourseList()
      }
    }
  },
  methods: {
    // 搜索
    searchButton() {
      this.initCourseList()
    },
    // 切换页码操作
    async switchPaging() {
      this.initCourseList()
    },
    // 响应添加按钮
    async addButton() {
      this.$router.push(this.$route.path+'/create')
    },
    // 响应编辑按钮
    async editButton(id) {
      this.$router.push(this.$route.path+'/'+id+'/edit')
    },
    // 相应删除按钮
    async deleteButton(id) {
      let info = await this.$api.deleteCourse(id)
      if (info == 'ok') {
        this.$nextTick(() => {
          this.initCourseList('del')
        })
        this.$notify.success('删除成功!')
      } else {
        this.$message.error(info)
      }
      
    },
    // 初始化课程列表
    async initCourseList(type) {
      this.loadingStaus=true
      let pagingInfo = this.$refs['apeTable'].getPagingInfo(type)
      let searchCondition = this.handleSearchCondition()
      Object.assign(searchCondition,pagingInfo)
      let {list,pages}= await this.$api.getCourseList(searchCondition)
      this.courseList = []
      this.$nextTick(() => {
        this.courseList=list
      })
      this.pagingData.total = pages.total
      this.pagingData.offset = pages.offset
      this.loadingStaus=false
    },
    // 处理搜索条件
    handleSearchCondition() {
      let condition = {}
      if (this.searchCondition.selected_category.length) {
        condition.category_id = this.searchCondition.selected_category[this.searchCondition.selected_category.length-1]
      }
      if (this.searchCondition.title) {
        condition.title = this.searchCondition.title
      }
      if (this.searchCondition.time_value) {
        condition.start_time = this.searchCondition.time_value[0]
        condition.end_time = this.searchCondition.time_value[1]
      }

      return condition
    },
    // 获取课程分类列表
    async getCategoryList() {
      // 获取课程分类列表
      let data = await this.$api.getCourseCategoryList()
      this.searchCourse = data.category
    },
  },
  mounted() {
    this.getCategoryList()
    this.initCourseList()
  }
}
</script>

<style lang="stylus">
  .el-button
    margin-right 4px
  .table-header
    margin-bottom 12px
  .el-input-group__prepend, .el-input-group__append
    background #ffffff
    padding 0 12px
  .el-input-group__append
    color #ffffff
    background #1890ff
  .el-popover .el-checkbox-group .el-checkbox
    margin-left 0px
    margin-right 12px
</style>
